import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {PageTitle} from "../../../../Components/Landmarks";
import {SearchResultsContainer} from "../../../../Components/SearchResults/SearchResultsContainer";
import {locations} from "../../../../Utilities/Location";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {loanLibraryCatalogApi} from "./loanLibraryCatalogApi";
import {loanLibraryQueueApi} from "../LoanLibraryQueue/loanLibraryQueueApi";
import {LoanLibraryCatalogItem} from "./LoanLibraryCatalogItem";
import {SYSTEM_TYPES} from "../../libraryConstants";

export const LoanLibraryCatalogWhatsNewContainer = ({
                                                        handleApiCall,
                                                        redirect,
                                                    }: ContextProps) => {
    const [resources, setResources] = useState<Record<string, any>[]>([]);

    const handleEdit = (id: string) => {
        const path = locations.LOAN_LIBRARY_CATALOG_ITEM.getLink([id, SYSTEM_TYPES.LoanLibrary]).to;
        redirect(path);
    }

    const getResources = () => {
        handleApiCall(() => loanLibraryCatalogApi.getWhatsNew(), (results: Record<string, any>[]) => setResources(results));
    };

    const handleAddToQueue = (id: string) => {
        handleApiCall(() => loanLibraryQueueApi.addToQueue(id), () => {
            getResources();
        });
    };

    useEffect(() => {
        getResources();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>
        <PageTitle h1="Loan Library"/>

        <SearchResultsContainer title="What's New">
            {
                resources.map((resource: Record<string, any>) => {
                    const handleClickEdit = () => handleEdit(resource.loanLibraryCatalogId);
                    const handleClickAddToQueue = () => handleAddToQueue(resource.loanLibraryCatalogId);
                    return <LoanLibraryCatalogItem
                        key={resource.loanLibraryCatalogId}
                        handleClickEdit={handleClickEdit}
                        handleClickAddToQueue={handleClickAddToQueue}
                        {...resource}
                    />;
                })
            }
            {
                isArrayNullOrEmpty(resources) &&
                <p className={`text-center`}>No results.</p>
            }
        </SearchResultsContainer>
    </>;
};

